import React, { useEffect, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import DynamicTable from "../DynamicTable/DynamicTable";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import he from 'he';
import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import { Button, Typography } from "@mui/material";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import IconButton from '@mui/material/IconButton';

export default function UserOFACTable({
  ofacData,
  handleSelectedUser,
  targetID,
  systemRoles,
  userStatus,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const pageCount = Math.ceil(ofacData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const [usersTable, setUsersTable] = useState(null);
  const [openOFACHistoryDrawer, setOpenOFACHistoryDrawer] = useState(false);
  const [selectedOFACHistory, setSelectedOFACHistory] = useState({});
  const [isDarkMode, setIsDarkMode] = useState(false);

  // console.log(pageCount, pageNumbers)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // console.log(ofacData)

  async function getTable() {
    let response = await fetch(`/tables/userOFACTable.json`);
    // let response = await fetch(`/tables/operatorTable.json`);
    const tableData = await response.json();
    console.log("tableData==========",tableData);
    console.log("ofacData==========",ofacData);
    setUsersTable(tableData);
    setRowsPerPage(tableData.rowsPerPage);
  }

  useEffect(() => {
    getTable();
  }, []);

  const handleViewHistoryDetails = async (data) => {
    try {
      // Unescape HTML-encoded string
      const unescaped = he.decode(data?.userofac_history?.ofac_payload || '');
  
      // Parse the JSON string to object
      const parsedPayload = JSON.parse(unescaped);
  
      setSelectedOFACHistory(parsedPayload);
      setOpenOFACHistoryDrawer(true);
    } catch (error) {
      console.error("Error parsing ofac_payload:", error);
      setOpenOFACHistoryDrawer(false);
    }
  };

  return (
    <>
      <TableContainer sx={{ boxShadow: "none", }}>
        {usersTable && (
          <DynamicTable
            tableData={ofacData}
            tableSource={usersTable}
            page={page}
            handleEdit={handleSelectedUser}
            targetID={targetID}
            twoColumn={false}
            roles={systemRoles}
            userStatus={userStatus}
            handleButton={handleViewHistoryDetails}
          />
        )}
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>

      <BaseDrawer
        open={openOFACHistoryDrawer}
        handleClose={() => setOpenOFACHistoryDrawer(false)}
        height="85vh"
      >
        <div style={{ padding: '16px', maxHeight: '100%', overflowY: 'auto' }}>
          {/* <pre style={{ background: '#f5f5f5', padding: '16px', borderRadius: '8px', fontSize: '14px' }}>
            {JSON.stringify(selectedOFACHistory, null, 2)}
          </pre> */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6, marginBottom: 8 }}>
            <div >
              <Typography>OFAC Response JSON:</Typography>
            </div>

            {/* Dark and Light Mode btns */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6,}}>
              <button
                onClick={() => setIsDarkMode(prev => !prev)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  fontSize: '0.9rem',
                  color: 'inherit'
                }}
                aria-label="toggle dark/light mode"
              >
                {isDarkMode ? <WbSunnyIcon /> : <DarkModeIcon />}
                <span style={{ userSelect: 'none' }}>
                  {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                </span>
              </button>
            </div>
          </div>

          <JsonView
            data={selectedOFACHistory}
            shouldExpandNode={allExpanded} // expand all levels (can customize)
            style={isDarkMode ? darkStyles : defaultStyles}             // or defaultStyles
          />
        </div>
      </BaseDrawer>
    </>
  );
}
